import React from 'react'
import gql from 'graphql-tag'
import { makesQueries } from 'data/graphql'
import { connect } from 'react-redux'
import { compose, withState, branch } from 'recompose'
import { selectors as UISelectors } from 'data/ui'
import EmbeddableTypes from '@slite/editor/lib/types/EmbeddableTypes'

const applicationByEmbedTypeQuery = gql`
  query getApplicationByEmbedType($embedType: EmbedType!, $userId: ID!) {
    getApplicationByEmbedType(embedType: $embedType) {
      id
      name
      labels {
        shareToAction
        shareToActionVerb
        shareToSuccess
        shareToSuccessLinkLabel
        userConnectIncentive
      }
      photoURL
      isInstalled
      integration {
        hasAuthenticationForUser(userId: $userId)
      }
    }
  }
`

const MakeQuery = makesQueries({
  query: applicationByEmbedTypeQuery,
  mapPropsToVariables: ({ embedType, userId }) => ({ userId, embedType }),
  getOnResultFromProps({ setApplication, setApplicationLoaded }) {
    return function providesApplicationByEmbedTypeOnResult({ result }) {
      setApplication(result.data.getApplicationByEmbedType)
      setApplicationLoaded(true)
    }
  },
  getOnErrorFromProps({ setApplication, setApplicationLoaded }) {
    return function providesApplicationByEmbedTypeOnError() {
      setApplication(null)
      setApplicationLoaded(true)
    }
  },
})

const FakeMakeQuery = function(Component) {
  return function fakeMakeQuery(props) {
    return <Component {...props} application={null} applicationLoaded={true} />
  }
}

export default function providesApplicationByEmbedType() {
  return compose(
    connect(state => {
      return {
        userId: UISelectors.getActiveUserId(state),
      }
    }),
    withState('application', 'setApplication', undefined),
    withState('applicationLoaded', 'setApplicationLoaded', false),
    // We don't want to make unnecessary queries
    branch(
      props => {
        const { embedType } = props

        const whitelisted = [
          EmbeddableTypes.GITHUB,
          EmbeddableTypes.ASANA,
          EmbeddableTypes.TRELLO,
          EmbeddableTypes.CLICKUP,
        ]

        return whitelisted.includes(embedType)
      },
      MakeQuery,
      FakeMakeQuery
    )
  )
}
